import { motion } from "framer-motion";

const hexPoints = (r) =>
  Array.from({ length: 6 }, (_, i) => {
    const a = Math.PI / 6 + (i * Math.PI) / 3;
    return `${(100 + Math.cos(a) * r).toFixed(2)},${(100 + Math.sin(a) * r).toFixed(2)}`;
  }).join(" ");

const threadTicks = Array.from({ length: 48 });

/* Hex-nut + thread-profile watermark — the shape we actually make */
export default function NutMotif({
  size = 520,
  className = "",
  color = "#1B5FAA",
  opacity = 0.07,
  reverse = false,
  duration = 80,
}) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={`pointer-events-none select-none absolute ${className}`}
      style={{ opacity }}
      animate={{ rotate: reverse ? -360 : 360 }}
      transition={{ duration, repeat: Infinity, ease: "linear" }}
      aria-hidden="true"
      data-testid="nut-motif"
    >
      <g fill="none" stroke={color}>
        {/* across-corners hex body */}
        <polygon points={hexPoints(88)} strokeWidth="3" />
        {/* chamfer line */}
        <polygon points={hexPoints(78)} strokeWidth="1" strokeDasharray="6 5" />
        {/* bore */}
        <circle cx="100" cy="100" r="42" strokeWidth="3" />
        {/* thread crest ticks inside the bore */}
        {threadTicks.map((_, i) => {
          const a = (i / threadTicks.length) * Math.PI * 2;
          return (
            <line
              key={`thread-${a.toFixed(3)}`}
              x1={100 + Math.cos(a) * 42}
              y1={100 + Math.sin(a) * 42}
              x2={100 + Math.cos(a) * 34}
              y2={100 + Math.sin(a) * 34}
              strokeWidth="2"
              strokeLinecap="round"
            />
          );
        })}
        {/* corner witness marks */}
        {Array.from({ length: 6 }).map((_, i) => {
          const a = Math.PI / 6 + (i * Math.PI) / 3;
          return (
            <line
              key={`c-${i}`}
              x1={100 + Math.cos(a) * 88}
              y1={100 + Math.sin(a) * 88}
              x2={100 + Math.cos(a) * 97}
              y2={100 + Math.sin(a) * 97}
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          );
        })}
      </g>
    </motion.svg>
  );
}
